import React from 'react';

const Dex = () => {
  return (
    <div className="dark:text-white px-4 py-8">
      <h2 className="font-vt323 text-[44px] text-center mb-6">BUY $START</h2>
      <div className="flex justify-center">
        <iframe
          src="https://jup.ag/swap/SOL-TROLL"
          title="Jupiter Swap"
          width="100%"
          height="600"
          style={{
            width: '480px',
            maxWidth: '600%',
            border: 'none',
            borderRadius: '12px',
            overflow: 'hidden',
          }}
        />
      </div>
    </div>
  );
};

export default Dex;
